export default class Queue {
    waitingList = []
    doingCount = 0
    constructor(maxCount = 5, doFn, waitFn) {
      this.maxCount = maxCount
      this.doFn = doFn
      this.waitFn = waitFn
    }

    preDo(payload) {
      if (this.doingCount - this.maxCount < 0) {
        this.doingCount += 1
        this.doFn(payload)
      } else {
        this.queueWait(payload)
      }
    }

    queueWait(payload) {
      this.waitFn && this.waitFn(payload)
      this.waitingList.push(payload)
    }

    nextDo() {
      this.doingCount -= 1
      const nextItem = this.waitingList.splice(0, 1)[0]
      if (nextItem) {
        this.preDo(nextItem)
      }
    }
}
